const DONUT_COLORS = ['#E8734A', '#4FC3C9', '#F2B14C', '#B98CD6', '#6BCB77', '#FF6B8A', '#45AAF2', '#FFA94D', '#A5D8FF', '#7E9AA0'];

const REGION_COLORS = {
  'United States': '#E8734A', 'Canada': '#E8734A', 'Jamaica': '#E8734A', 'Dominican Republic': '#E8734A',
  'Puerto Rico': '#E8734A', 'Bahamas': '#E8734A', 'Trinidad and Tobago': '#E8734A', 'Barbados': '#E8734A',
  'Guyana': '#E8734A', 'Colombia': '#E8734A', 'Peru': '#E8734A', 'Uruguay': '#E8734A', 'Panama': '#E8734A',
  'Guatemala': '#E8734A', 'Mexico': '#E8734A', 'Aruba': '#E8734A', 'Curacao': '#E8734A',
  'Saint Lucia': '#E8734A', 'Saint Kitts And Nevis': '#E8734A', 'Turks and Caicos Islands': '#E8734A',
  'Netherlands Antilles': '#E8734A', 'Martinique': '#E8734A', 'Guadeloupe': '#E8734A',
  'American Samoa': '#E8734A', 'Greenland': '#E8734A', 'Guam': '#E8734A',

  'United Kingdom': '#4FC3C9', 'Belgium': '#4FC3C9', 'Netherlands': '#4FC3C9', 'Germany': '#4FC3C9',
  'France': '#4FC3C9', 'Spain': '#4FC3C9', 'Italy': '#4FC3C9', 'Portugal': '#4FC3C9',
  'Greece': '#4FC3C9', 'Poland': '#4FC3C9', 'Lithuania': '#4FC3C9', 'Romania': '#4FC3C9',
  'Ireland': '#4FC3C9', 'Ukraine': '#4FC3C9', 'Denmark': '#4FC3C9', 'Sweden': '#4FC3C9',
  'Norway': '#4FC3C9', 'Latvia': '#4FC3C9', 'Estonia': '#4FC3C9', 'Slovenia': '#4FC3C9',
  'Croatia': '#4FC3C9', 'Bulgaria': '#4FC3C9', 'Austria': '#4FC3C9', 'Malta': '#4FC3C9',
  'Cyprus': '#4FC3C9', 'Albania': '#4FC3C9', 'Belarus': '#4FC3C9', 'Georgia': '#4FC3C9',
  'Iceland': '#4FC3C9', 'Switzerland': '#4FC3C9', 'Turkey': '#4FC3C9', 'Azerbaijan': '#4FC3C9',
  'Kazakhstan': '#4FC3C9',

  'Russia': '#4FC3C9',

  'China': '#F2B14C', 'Japan': '#F2B14C', 'Vietnam': '#F2B14C', 'Thailand': '#F2B14C',
  'Malaysia': '#F2B14C', 'South Korea': '#F2B14C', 'Hong Kong': '#F2B14C', 'Taiwan': '#F2B14C',
  'Singapore': '#F2B14C', 'Indonesia': '#F2B14C', 'Myanmar': '#F2B14C', 'Brunei': '#F2B14C',
  'Sri Lanka': '#F2B14C', 'Nepal': '#F2B14C', 'Bhutan': '#F2B14C', 'Bangladesh': '#F2B14C',
  'India': '#F2B14C', 'Maldives': '#F2B14C',

  'United Arab Emirates': '#B98CD6', 'Kuwait': '#B98CD6', 'Qatar': '#B98CD6',
  'Bahrain': '#B98CD6', 'Oman': '#B98CD6', 'Saudi Arabia': '#B98CD6',
  'Jordan': '#B98CD6', 'Lebanon': '#B98CD6', 'Israel': '#B98CD6', 'Iraq': '#B98CD6',
  'Syria': '#B98CD6',

  'South Africa': '#6BCB77', 'Mauritius': '#6BCB77', 'Reunion': '#6BCB77',
  'Seychelles': '#6BCB77', 'Ghana': '#6BCB77', 'Kenya': '#6BCB77', 'Nigeria': '#6BCB77',
  'Ivory Coast': '#6BCB77', 'Morocco': '#6BCB77', 'Algeria': '#6BCB77', 'Egypt': '#6BCB77',
  'Angola': '#6BCB77', 'Djibouti': '#6BCB77', 'Gabon': '#6BCB77', 'Mauritania': '#6BCB77',
  'Tanzania': '#6BCB77', 'Zambia': '#6BCB77', 'Mayotte': '#6BCB77',

  'Australia': '#45AAF2', 'New Zealand': '#45AAF2', 'Fiji': '#45AAF2',
};

export const fmtM = (v) => {
  if (v >= 1e9) return '$' + (v / 1e9).toFixed(2) + 'B';
  if (v >= 1e6) return '$' + (v / 1e6).toFixed(v / 1e6 >= 100 ? 0 : v / 1e6 >= 10 ? 1 : 2) + 'M';
  if (v >= 1e3) return '$' + (v / 1e3).toFixed(0) + 'k';
  return '$' + v.toFixed(0);
};

export const fmtT = (v) => {
  if (v >= 1e6) return (v / 1e6).toFixed(1) + 'M t';
  if (v >= 1e3) return (v / 1e3).toFixed(1) + 'k t';
  return v.toFixed(1) + ' t';
};

export const fmtK = (v) => {
  if (v >= 1e9) return '$' + (v / 1e9).toFixed(2) + 'B';
  if (v >= 1e6) return '$' + (v / 1e6).toFixed(1) + 'M';
  if (v >= 1e3) return '$' + (v / 1e3).toFixed(0) + 'k';
  return '$' + v.toFixed(0);
};

export const fmtN = (v) => {
  if (v >= 1e6) return (v / 1e6).toFixed(1) + 'M';
  if (v >= 1e3) return (v / 1e3).toFixed(1) + 'k';
  return String(v);
};

export const getRegionColor = (country) => REGION_COLORS[country] || '#7E9AA0';

// Fixed per-chart accent gradients — ported verbatim from the legacy intelligence.html
// (`bars('bExp',...,'linear-gradient(90deg,#FF8A6E,#FF6B52)')` / `bars('bSize',...,'linear-gradient(90deg,#7FE3E0,#4FC3C9)')`)
// so Top Exporters / Size Grades match the original pixel-for-pixel instead of the
// app's dash-coral/dash-ice tokens, which are visually similar but not the same hex
// values. Kept as literal Tailwind arbitrary-value class fragments (not hex objects)
// so Tailwind's static content scanner can still find and generate them.
export const BAR_GRADIENTS = {
  coral: 'from-[#FF8A6E] to-[#FF6B52]',
  ice: 'from-[#7FE3E0] to-[#4FC3C9]',
};

// Coast colors for the Origin Ports (India) map — same C.coral/C.ice/C.amber used by
// the legacy dashboard's `cc={East:C.coral,West:C.ice,Inland:C.amber}`.
export const COAST_COLORS = { East: '#FF6B52', West: '#4FC3C9', Inland: '#F2B14C' };

export { DONUT_COLORS, REGION_COLORS };
